// frontend/src/components/PnLCard.tsx
import Button from "@mui/material/Button";
import { FC, useEffect, useState } from "react";
import useDrawerStore from "store/DrawerStore";

const TradingSymbol: FC<any> = ({ symbol }) => {
  const { setSelectedSymbol } = useDrawerStore();

  return (
    <Button variant="text" onClick={() => setSelectedSymbol(`BSE:${symbol}`)}>
      {symbol}
    </Button>
  );
};

export default TradingSymbol;
